export enum ConfigType {
    Agent = 1,    
    SharedFile = 2,
    Template = 3
}